export default __webpack_public_path__ + "../img/640d0b1e39b36fd2550c24f1e0237438.png";